import { useEffect, useState } from "react";
import { Users, TrendingUp } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BadgePill, BADGE_STYLES } from "@/components/Badges";

export const MyInvitesCard = () => {
  const { user } = useAuth();
  const [me, setMe] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/leaderboard/me").then(({ data }) => alive && setMe(data)).catch(() => {});
    return () => { alive = false; };
  }, [user?.invites]);

  if (!me) return null;
  const tierStart = me.badge?.min || 0;
  const tierEnd = me.next_badge?.min || tierStart || 1;
  const pct = me.next_badge ? Math.min(100, Math.round(((me.invites - tierStart) / (tierEnd - tierStart)) * 100)) : 100;
  const color = BADGE_STYLES[me.next_badge?.id || me.badge?.id || "bronze"].hex;

  return (
    <div className="rounded-xl border border-talanta-green/10 bg-white p-4" data-testid="my-invites-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-talanta-charcoal/50">
          <Users className="h-3.5 w-3.5" /> Your invites
        </div>
        {me.badge ? <BadgePill badge={me.badge} testId="my-badge" /> : <span className="text-[11px] text-talanta-charcoal/40">No badge yet</span>}
      </div>
      <div className="mt-2 flex items-end gap-3">
        <div className="font-display font-extrabold text-3xl text-talanta-green" data-testid="my-invites-count">{me.invites}</div>
        <div className="pb-1 text-xs text-talanta-charcoal/60">
          {me.rank ? (
            <span data-testid="my-rank">#{me.rank} in Kenya{me.county_rank ? ` · #${me.county_rank} in ${me.county}` : ""}</span>
          ) : (
            "friends joined through your ID"
          )}
        </div>
      </div>
      <div className="mt-3 h-2 rounded-full bg-talanta-cream overflow-hidden">
        <div className="h-full rounded-full transition-all" style={{ width: `${Math.max(pct, me.invites > 0 ? 6 : 0)}%`, background: color }} />
      </div>
      <p className="mt-2 text-xs text-talanta-charcoal/60 flex items-center gap-1" data-testid="my-next-badge">
        <TrendingUp className="h-3 w-3" />
        {me.next_badge ? `${me.remaining} more invite${me.remaining === 1 ? "" : "s"} to ${me.next_badge.label}` : "You've reached the top tier — Champion!"}
      </p>
    </div>
  );
};
